import { TileProps } from "./types";
import FantasyTournamentTile from "./FantasyTournamentTile";

const FantasyTournamentTileContainer: React.FC<TileProps> = (props) => {

  return <FantasyTournamentTile {...props} />;
};

export default FantasyTournamentTileContainer;
